import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../../Network/API";
import ShareMeeting from "../Modal/ShareMeeting";
import PostLoader from '../../assets/img/loader.gif';
export default function MeetingDetails() {
  const myArr = JSON.parse(localStorage.getItem('user_data'));
  const [meetingData, setMeetingData] = useState([]);
  const [progress, setProgress] = useState(false);
  let { room } = useParams();
  const [modalDialog, setModalDialog] = useState(false);
  const [sc_meet, setScMeet] = useState(null);


  const toggleModal = (meeting_room) => {
    setScMeet(meeting_room)
    setModalDialog(!modalDialog)
};

  useEffect(() => {
    setProgress(true)
    API.get('/v1/meeting_details/' + room).then((response) => {
      setMeetingData(response.data.data);
      setProgress(false)
    }).catch((error) => {
      setProgress(true)
    });

  }, [room]);
  return (
  <>
      {progress ? (
        <div className="min-vh-100 bg-white d-flex align-items-center justify-content-center">
          <div className="text-center">
            <div className="spinner-border text-dark mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted">Loading meeting details...</p>
          </div>
        </div>
      ) : (
        <div className="min-vh-100 bg-white">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-xl-5">
                <div className="text-center">
                  <Link
                    to="/meeting"
                    className="btn btn-outline-dark rounded-pill px-3 py-1 d-flex align-items-center justify-content-center mb-5"
                    style={{ fontSize: '12px', fontWeight: '500', width: 'fit-content', margin: '0 auto 2rem auto' }}
                  >
                    <i className="fa-solid fa-arrow-left me-1" style={{ fontSize: '10px' }}></i>
                    Back to Meetings
                  </Link>
                  
                  <div className="mb-5">
                    <h1 className="fw-bold text-dark mb-2" style={{ fontSize: '28px', letterSpacing: '-0.5px' }}>
                      {meetingData?.room_title}
                    </h1>
                    {meetingData?.note && (
                      <p className="text-muted mb-0" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                        {meetingData?.note}
                      </p>
                    )}
    </div>
    
                  <div className="mb-5">
                    <div className="row g-2">
                      <div className="col-6">
                        <div className="bg-light rounded-3 p-3 h-100">
                          <i className="fa-solid fa-calendar text-dark mb-2" style={{ fontSize: '16px' }}></i>
                          <div className="fw-semibold text-dark" style={{ fontSize: '13px' }}>
                  {meetingData?.start_text}
                </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded-3 p-3 h-100">
                          <i className="fa-solid fa-clock text-dark mb-2" style={{ fontSize: '16px' }}></i>
                          <div className="fw-semibold text-dark" style={{ fontSize: '13px' }}>
                  {meetingData?.start_time_text}
                          </div>
                        </div>
                      </div>
                </div>
              </div>

                  {meetingData?.user_id == myArr.id ? (
                    <div className="mb-5">
                      <h6 className="fw-semibold text-dark mb-3" style={{ fontSize: '14px' }}>
                        Participants
                      </h6>
                      <div className="d-flex justify-content-center align-items-start flex-wrap gap-3">
                    {meetingData?.total_invites > 0 && meetingData?.users.map((user, index) => (
                          <Link key={index} to={`/contact/${user.id}`} className="text-decoration-none">
                            <div className="d-flex flex-column align-items-center" style={{ maxWidth: '60px' }}>
                              <div 
                                className="rounded-circle shadow-sm mb-2" 
                                style={{ 
                                  width: '48px', 
                                  height: '48px',
                                  backgroundImage: `url(${user.avatar})`,
                                  backgroundSize: 'cover',
                                  backgroundPosition: 'center',
                                  border: '2px solid #f8f9fa'
                                }} 
                              />
                              <span className="text-dark text-center fw-medium" style={{ 
                                fontSize: '11px', 
                                lineHeight: '1.2',
                                wordBreak: 'break-word',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                              }}>
                                {user.name}
                              </span>
                            </div>
                          </Link>
                        ))}
                        <button
                          className="btn btn-light rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                          onClick={() => toggleModal(meetingData)}
                          style={{ 
                            width: '48px', 
                            height: '48px',
                            border: '2px solid #e9ecef',
                            transition: 'all 0.2s ease'
                          }}
                          title="Add participants"
                          onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                          onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                        >
                          <i className="fa-solid fa-plus text-muted" style={{ fontSize: '14px' }}></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="mb-5">
                      <h6 className="fw-semibold text-dark mb-3" style={{ fontSize: '14px' }}>
                        Host
                      </h6>
                      <div className="d-flex justify-content-center align-items-center">
                        <Link to={`/contact/${meetingData?.user_id}`} className="text-decoration-none">
                          <div className="d-flex flex-column align-items-center">
                            <div 
                              className="rounded-circle shadow-sm mb-2" 
                              style={{ 
                                width: '56px', 
                                height: '56px',
                                backgroundImage: `url(${meetingData?.avatar})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                border: '2px solid #f8f9fa'
                              }} 
                            />
                            <h6 className="fw-semibold text-dark mb-0" style={{ fontSize: '13px' }}>
                              {meetingData?.created_by}
                            </h6>
                            <small className="text-muted" style={{ fontSize: '11px' }}>Meeting Host</small>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}

                  <div className="text-center">
                    <Link 
                      className="btn btn-dark rounded-pill px-5 py-3 shadow-sm" 
                      to={`/meeting/${meetingData?.room_name}`} 
                      role="button"
                      style={{ 
                        fontSize: '14px', 
                        fontWeight: '500',
                        minWidth: '200px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <i className="fa-solid fa-video me-2" style={{ fontSize: '12px' }}></i>
                      {meetingData?.user_id == myArr.id ? 'Start Meeting' : 'Join Meeting'}
                    </Link>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    <ShareMeeting isModalVisible={modalDialog} meetingRoom={sc_meet} handleShowB={() => setModalDialog(false)}/>
    </>
  )
}